


























































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import { ManagementReportsModule } from '@/store/modules/managementReports';
import { formatCurrency, formatNumber } from '@/lib/reportFormatters';

@Component({ name: 'FinancialReports' })
export default class FinancialReports extends GiganautVue {

  get workerLabel(): string { return this.Labels.worker || 'Worker'; }
  get workersLabel(): string { return this.Labels.workers || 'Workers'; }

  get payrollHeaders() {
    return [
      { text: 'Position', value: 'label' },
      { text: 'Total', value: 'total', align: 'end' },
      { text: this.workersLabel, value: 'workers', align: 'end' },
      { text: 'Avg Rate', value: 'avgRate', align: 'end' },
    ];
  }

  get payrollSummary() { return ManagementReportsModule.payrollSummary; }

  fmtCurrency(v: number) { return formatCurrency(v); }
  fmtNum(v: number) { return formatNumber(v); }
}
